import { useCallback, useContext } from 'react';
import ModalContext from '~/context/vdp/ModalContext';
import { useShouldShowConfirmationModal } from '~/hooks/vdp/selectors/useConfirmModalCases';

function useConfirmBeforeLogin(): (onContinue: () => void) => () => void {
  const { setConfirmModalOpen } = useContext(ModalContext);
  const shouldShowConfirmationModal = useShouldShowConfirmationModal();

  return useCallback(
    (onContinue: () => void) => () => {
      if (shouldShowConfirmationModal) {
        setConfirmModalOpen(true, {
          onContinue: () => {
            setConfirmModalOpen(false);
            onContinue();
          },
          onlyConfirmCancellation: false
        });
      } else {
        onContinue();
      }
    },
    [setConfirmModalOpen, shouldShowConfirmationModal]
  );
}

export default useConfirmBeforeLogin;
